import React from 'react';
import './WithBackgroundImage.css';

const WithBackgroundImage = props => {
  const { image, children, className } = props;
  return (
    <div
      className={`with-background-image-hoc ${className}`}
      style={{ backgroundImage: `url(${image})` }}
    >
      {children}
    </div>
  );
};

export default WithBackgroundImage;
